// export const SENTIMENT_BASE_URL = 'http://127.0.0.1:8787/';

export const SENTIMENT_BASE_URL = 'https://sentiment.graph.gv.my/';
export const HIGHLIGHT_COLOUR = '#4dffdf';
export const TWEETS_BASE_URL = 'https://55c9cm45v3.execute-api.us-east-1.amazonaws.com/';